(function () {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const panel = drawer.querySelector('[data-cart-drawer-panel]');
  const linesEl = drawer.querySelector('[data-cart-drawer-lines]');
  const emptyEl = drawer.querySelector('[data-cart-drawer-empty]');
  const footerEl = drawer.querySelector('[data-cart-drawer-footer]');
  const subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
  const shippingEl = drawer.querySelector('[data-cart-drawer-shipping]');
  const recsSection = drawer.querySelector('[data-cart-drawer-recs]');
  const recsGrid = drawer.querySelector('[data-cart-drawer-recs-grid]');
  const recsEyebrow = drawer.querySelector('[data-cart-drawer-recs-eyebrow]');
  const recsHeading = drawer.querySelector('[data-cart-drawer-recs-heading]');
  const threshold = Number(drawer.dataset.freeShippingThreshold || 100) * 100;
  const flatRate = Number(drawer.dataset.flatShippingRate || 11) * 100;
  const shippingCostEl = drawer.querySelector('[data-cart-drawer-shipping-cost]');
  const launchWeekend = drawer.dataset.launchWeekend === '1';
  const moneyFormat = drawer.dataset.moneyFormat || '${{amount}}';

  let curatedAddons = [];
  try {
    const raw = drawer.querySelector('[data-cart-drawer-addons]')?.textContent || '[]';
    curatedAddons = JSON.parse(raw).filter((item) => item && item.id && item.available !== false);
  } catch (err) {
    curatedAddons = [];
  }

  const formatMoney = (cents) => {
    const amount = (Number(cents) / 100).toFixed(2);
    if (moneyFormat.includes('{{amount_no_decimals}}')) {
      return moneyFormat.replace('{{amount_no_decimals}}', String(Math.round(Number(cents) / 100)));
    }
    return moneyFormat
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount}}', amount);
  };

  const updateBagCount = (count) => {
    document.querySelectorAll('a[href*="/cart"]').forEach((link) => {
      if (/Bag\s*\(/i.test(link.textContent)) {
        link.textContent = `Bag (${count})`;
      }
    });
  };

  /* @gap-suggestions */
  const GAP_OVERSHOOT_CENTS = 1500;
  const GAP_PRICE_CAP_CENTS = 4000;
  const GAP_PICK_LIMIT = 3;
  const WALK_CART_HINTS = ['glowtrail', 'ironwalk', 'reachlock', 'trailgrip', 'trailscoop', 'glowcatch', 'cattrail', 'trailpack'];
  const CAR_CART_HINTS = ['hardbench', 'bootguard', 'rearrealm', 'cabinclip', 'copilot'];

  function lineHaystack(item) {
    return [item && item.handle, item && item.url, item && item.product_title, item && item.title, item && item.product_type]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
  }

  function cartJourney(cart) {
    let walk = false;
    let car = false;
    (cart.items || []).forEach((item) => {
      const hay = lineHaystack(item);
      if (WALK_CART_HINTS.some((hint) => hay.includes(hint))) walk = true;
      if (CAR_CART_HINTS.some((hint) => hay.includes(hint))) car = true;
    });
    if (walk && car) return 'mixed';
    if (walk) return 'walk';
    if (car) return 'car';
    return 'open';
  }

  function suggestionOffer(addon, gapCents) {
    const ceiling = Math.min(GAP_PRICE_CAP_CENTS, gapCents + GAP_OVERSHOOT_CENTS);
    const variants = Array.isArray(addon.variants) && addon.variants.length
      ? addon.variants
      : [];
    let best = null;
    variants.forEach((variant) => {
      const price = Number(variant.price) || 0;
      if (variant.available === false || price <= 0 || price > ceiling || price > GAP_PRICE_CAP_CENTS) return;
      const distance = Math.abs(price - gapCents);
      if (!best || distance < best.distance || (distance === best.distance && price < best.price)) {
        best = { id: variant.id, price, distance };
      }
    });
    return best;
  }

  function pickGapSuggestions(cart, addons, thresholdCents) {
    const gapCents = Math.max(0, Number(thresholdCents) - Number(cart.total_price || 0));
    if (gapCents <= 0 || !(cart.items || []).length) {
      return { gapCents, journey: 'open', picks: [] };
    }

    const inCartIds = new Set((cart.items || []).map((item) => String(item.product_id)));
    const journey = cartJourney(cart);
    const ranked = [];

    (addons || []).forEach((addon) => {
      if (!addon || inCartIds.has(String(addon.id))) return;
      const title = String(addon.title || '').toLowerCase();
      const handle = String(addon.handle || addon.key || '').toLowerCase();
      if (addon.giftCard || title.includes('gift card') || handle.includes('gift-card') || handle === 'gift') return;
      if (title.includes('carrier') || handle.includes('carrier')) return;
      const offer = suggestionOffer(addon, gapCents);
      if (!offer) return;
      let score = offer.distance;
      const family = addon.family || 'open';
      if (journey === 'walk' && family !== 'walk') score += 100000;
      if (journey === 'car' && family !== 'car') score += 100000;
      ranked.push({
        ...addon,
        price: offer.price,
        variantId: offer.id,
        distance: offer.distance,
        score,
        closes: offer.price >= gapCents,
        chooseOnPage: addon.chooseOnPage === true || (Array.isArray(addon.variants) && addon.variants.length > 1)
      });
    });

    ranked.sort((a, b) => a.score - b.score || a.price - b.price || String(a.handle).localeCompare(String(b.handle)));

    const picks = [];
    ranked.forEach((candidate) => {
      if (picks.length >= GAP_PICK_LIMIT) return;
      if (picks.some((pick) => pick.id === candidate.id || pick.handle === candidate.handle)) return;
      picks.push(candidate);
    });

    if (picks.length && !picks.some((pick) => pick.closes)) {
      const cheaper = ranked
        .filter((pick) => pick.price < gapCents)
        .sort((a, b) => a.distance - b.distance || a.price - b.price);
      cheaper.forEach((candidate) => {
        if (picks.length >= GAP_PICK_LIMIT) return;
        if (picks.some((pick) => pick.id === candidate.id)) return;
        picks.push(candidate);
      });
    }

    return { gapCents, journey, picks: picks.slice(0, GAP_PICK_LIMIT) };
  }
  /* @gap-suggestions-end */

  const renderShipping = (totalPrice) => {
    if (!shippingEl) return;
    if (launchWeekend) {
      shippingEl.innerHTML = '<strong>FREE AU SHIPPING on every order</strong><span>Launch Weekend. No minimum spend. Ends Sunday 11:59PM.</span>';
      return;
    }
    if (totalPrice >= threshold) {
      shippingEl.innerHTML = "<strong>You've unlocked FREE Australian shipping.</strong>";
      return;
    }
    const remaining = threshold - totalPrice;
    shippingEl.innerHTML = `<strong>You're ${formatMoney(remaining)} away from FREE AU SHIPPING. Shipping is ${formatMoney(flatRate)} until then.</strong>`;
  };

  const escapeHtml = (value) => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const TRAILGRIP_LENGTHS = { S: '120 cm', M: '150 cm', L: '180 cm' };

  const lineVariantCopy = (item) => {
    const isTrailgrip = item.handle === 'trailgrip-nylon-rope-dog-lead';
    const options = Array.isArray(item.options_with_values) ? item.options_with_values : [];
    if (!isTrailgrip) {
      if (options.length) {
        return options.map((opt) => {
          const name = opt.name || '';
          const value = opt.value || '';
          const line = name ? `${name}: ${value}` : value;
          return `<p>${escapeHtml(line)}</p>`;
        }).join('');
      }
      if (!item.variant_title || item.variant_title === 'Default Title') return '';
      return `<p>${escapeHtml(item.variant_title)}</p>`;
    }
    const rows = options.map((opt) => {
      const name = opt.name || '';
      const value = opt.value || '';
      if (/size/i.test(name) && TRAILGRIP_LENGTHS[value]) {
        return `Lead length in your bag: ${value} · ${TRAILGRIP_LENGTHS[value]}`;
      }
      if (/colour|color/i.test(name)) return `Colour: ${value}`;
      return name ? `${name}: ${value}` : value;
    }).filter(Boolean);
    const detail = rows.length
      ? rows.map((row) => `<p>${escapeHtml(row)}</p>`).join('')
      : (item.variant_title ? `<p>${escapeHtml(item.variant_title)}</p>` : '');
    return `${detail}<p class="ff-cart-drawer__note">Choosing another length on the product page does not change this. Add to bag again to save a different length.</p>`;
  };

  const renderLines = (cart) => {
    if (!linesEl) return;
    if (!cart.items.length) {
      linesEl.innerHTML = '';
      emptyEl.hidden = false;
      footerEl.hidden = true;
      if (shippingEl) shippingEl.textContent = '';
      if (recsSection) recsSection.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    footerEl.hidden = false;
    linesEl.innerHTML = cart.items.map((item) => `
      <li class="ff-cart-drawer__line">
        <a class="ff-cart-drawer__image" href="${item.url}">
          ${item.image
            ? `<img class="js-white-bg-check" crossorigin="anonymous" src="${item.image}" alt="${item.product_title.replace(/"/g, '&quot;')}" width="72" height="72" loading="lazy">`
            : ''}
        </a>
        <div class="ff-cart-drawer__details">
          <a href="${item.url}">${item.product_title}</a>
          ${lineVariantCopy(item)}
          <p class="ff-cart-drawer__qty">Qty ${item.quantity}</p>
        </div>
        <div class="ff-cart-drawer__price">${formatMoney(item.final_line_price)}</div>
      </li>
    `).join('');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (shippingCostEl) {
      const free = launchWeekend || Number(cart.total_price) >= threshold;
      shippingCostEl.textContent = free ? 'FREE' : `${formatMoney(flatRate)} flat rate`;
      shippingCostEl.classList.toggle('is-free', free);
    }
    updateBagCount(cart.item_count);
  };

  const renderGapRecommendations = (cart) => {
    if (!recsSection || !recsGrid) return;
    if (!cart.items || !cart.items.length) {
      recsSection.hidden = true;
      return;
    }
    const { gapCents, picks } = pickGapSuggestions(cart, curatedAddons, threshold);
    renderShipping(cart.total_price);

    if (!picks.length || gapCents <= 0) {
      recsSection.hidden = true;
      return;
    }

    if (recsEyebrow) recsEyebrow.textContent = 'Close the gap';
    if (recsHeading) recsHeading.textContent = 'Suggested extras';

    recsGrid.innerHTML = picks.map((product) => {
      const stillNeeded = Math.max(0, gapCents - Number(product.price));
      const note = product.closes
        ? 'Unlocks free AU shipping'
        : `Still ${formatMoney(stillNeeded)} short of free shipping`;
      return `
        <a class="ff-cart-drawer__rec" href="${product.url}" data-gap-handle="${product.handle || ''}" data-choose-on-page="${product.chooseOnPage ? 'true' : 'false'}">
          ${product.image
            ? `<img class="js-white-bg-check" crossorigin="anonymous" src="${product.image}" alt="" width="120" height="120" loading="lazy">`
            : ''}
          <span class="ff-cart-drawer__rec-label">${product.label || 'Essential'}</span>
          <span>${product.title}</span>
          <strong>${formatMoney(product.price)}</strong>
          <em>${note}</em>
        </a>
      `;
    }).join('');
    recsSection.hidden = false;
  };

  const openDrawer = () => {
    drawer.hidden = false;
    document.documentElement.classList.add('ff-cart-drawer-open');
    panel?.focus?.();
  };

  const closeDrawer = () => {
    drawer.hidden = true;
    document.documentElement.classList.remove('ff-cart-drawer-open');
  };

  drawer.querySelectorAll('[data-cart-drawer-close]').forEach((el) => {
    el.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
  });

  const refreshCart = async () => {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    renderLines(cart);
    renderGapRecommendations(cart);
    document.dispatchEvent(new CustomEvent('ff:cart-updated'));
    openDrawer();
  };

  const handleAddForm = async (form, event) => {
    event.preventDefault();
    const addButton = form.querySelector('[data-add-to-cart], button[type="submit"]');
    if (addButton?.dataset.needsSize === 'true' || addButton?.disabled) {
      const prompt = form.querySelector('[data-size-prompt]');
      if (prompt) prompt.hidden = false;
      form.querySelector('.ff-variant-picker__option--size')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      return;
    }

    const formData = new FormData(form);
    if (!formData.get('id')) return;

    try {
      if (addButton) addButton.disabled = true;
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      if (!response.ok) throw new Error('add failed');
      await refreshCart();
    } catch (err) {
      form.submit();
    } finally {
      if (addButton && addButton.dataset.needsSize !== 'true') {
        addButton.disabled = false;
      }
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[action*="/cart/add"], form[data-product-form], .product-card__cart');
    if (!form) return;
    handleAddForm(form, event);
  });

  document.querySelectorAll('a[href*="/cart"]').forEach((link) => {
    if (link.closest('[data-cart-drawer]')) return;
    if (link.hasAttribute('data-cart-drawer-view-bag')) return;
    link.addEventListener('click', async (event) => {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        if (cart.item_count > 0) {
          event.preventDefault();
          renderLines(cart);
          renderGapRecommendations(cart);
          openDrawer();
        }
      } catch (err) {
        /* fall through to cart page */
      }
    });
  });

  window.FurFarCartDrawer = { open: openDrawer, close: closeDrawer, refresh: refreshCart };
})();
